module.exports = __webpack_public_path__ + "img/126ne.eb098740.svg";